var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", {
        attrs: {
          items: [{ text: "Reports", path: { name: "admin-reports" } }],
          name: "Account Billing Status",
          title: _vm.pageTitle,
        },
      }),
      _vm._v(" "),
      _c(
        "admin-panel",
        {
          attrs: { "with-header": "" },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c("div", { staticClass: "account-billing-header" }, [
                    _c("div", { staticClass: "account-billing-filters" }, [
                      _c(
                        "div",
                        { staticClass: "account-billing-filter" },
                        [
                          _c(
                            "label",
                            { attrs: { for: "billing-status-filter" } },
                            [_vm._v("Billing Status")]
                          ),
                          _vm._v(" "),
                          _c("b-form-select", {
                            attrs: {
                              id: "billing-status-filter",
                              options: _vm.billingStatusOptions,
                            },
                            on: { change: _vm.onFiltersChanged },
                            model: {
                              value: _vm.filters.billing_status,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "billing_status", $$v)
                              },
                              expression: "filters.billing_status",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "account-billing-filter" },
                        [
                          _c("label", { attrs: { for: "state-filter" } }, [
                            _vm._v("State"),
                          ]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            attrs: {
                              id: "state-filter",
                              options: _vm.stateOptions,
                            },
                            on: { change: _vm.onFiltersChanged },
                            model: {
                              value: _vm.filters.state,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "state", $$v)
                              },
                              expression: "filters.state",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "account-billing-filter account-billing-filter--search",
                        },
                        [
                          _c("label", { attrs: { for: "company-search" } }, [
                            _vm._v("Company / Account"),
                          ]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: {
                              id: "company-search",
                              placeholder:
                                "Search by company name or account ID",
                            },
                            on: { input: _vm.onSearchInput },
                            model: {
                              value: _vm.filters.search,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.filters,
                                  "search",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "filters.search",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "account-billing-actions" },
                      [
                        _c(
                          "b-btn",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            staticClass: "mr-2",
                            attrs: {
                              variant: "primary",
                              title: "Export CSV",
                              disabled: !_vm.rows.length,
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.downloadCsv.apply(null, arguments)
                              },
                            },
                          },
                          [_c("b-icon-download")],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-btn",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: {
                              variant: "primary",
                              title: "Reload Report",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.loadReport.apply(null, arguments)
                              },
                            },
                          },
                          [_c("b-icon-arrow-clockwise")],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("div", { staticClass: "text-muted mb-3" }, [
            _vm._v(
              "\n      One row per company account with its current billing and subscription status.\n    "
            ),
          ]),
          _vm._v(" "),
          _c("b-table", {
            attrs: {
              fields: _vm.columns,
              items: _vm.rows,
              "table-class": "text-nowrap",
              responsive: "",
              hover: "",
              "show-empty": "",
              "empty-text": "No accounts found",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "cell(company_name)",
                  fn: function (data) {
                    return [
                      _c("div", { staticClass: "company-name-cell" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(data.item.company_name) +
                            "\n        "
                        ),
                      ]),
                    ]
                  },
                },
                _vm._l(_vm.sortableColumns, function (column) {
                  return {
                    key: `head(${column.key})`,
                    fn: function () {
                      return [
                        _c(
                          "button",
                          {
                            key: `sort-${column.key}`,
                            staticClass:
                              "report-sort-head btn btn-link p-0 d-inline-flex align-items-center",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.toggleSort(column.key)
                              },
                            },
                          },
                          [
                            _c("span", [_vm._v(_vm._s(column.label))]),
                            _vm._v(" "),
                            _c("span", { staticClass: "ml-2" }, [
                              _vm._v(_vm._s(_vm.sortIcon(column.key))),
                            ]),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  }
                }),
                {
                  key: "cell(account_type)",
                  fn: function (data) {
                    return [
                      _c("span", { staticClass: "text-capitalize" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatAccountType(data.item.account_type)
                            ) +
                            "\n        "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell(billing_status)",
                  fn: function (data) {
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "billing-status-badge",
                          class: _vm.getBillingStatusClass(
                            data.item.billing_status
                          ),
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.formatBillingStatus(
                                  data.item.billing_status
                                )
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell(subscription_start_date)",
                  fn: function (data) {
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.formatDate(data.item.subscription_start_date)
                          ) +
                          "\n      "
                      ),
                    ]
                  },
                },
                {
                  key: "cell(most_recent_payment_date)",
                  fn: function (data) {
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.formatDate(data.item.most_recent_payment_date)
                          ) +
                          "\n      "
                      ),
                    ]
                  },
                },
                {
                  key: "cell(next_payment_date)",
                  fn: function (data) {
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.formatDate(data.item.next_payment_date)) +
                          "\n      "
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }